import { MessageCircle, Phone } from "lucide-react";
import { PHONE_FIXED_TEL, WA_MAIN } from "../constants/site";

export const FloatingButtons = () => (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3 items-end">
        <a
            href={PHONE_FIXED_TEL}
            data-testid="floating-call-btn"
            aria-label="Ligar agora para a TMZ Guincho"
            title="Ligar agora"
            className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-neutral-900 hover:bg-neutral-700 text-white flex items-center justify-center shadow-xl transition-colors"
        >
            <Phone className="w-5 h-5" />
        </a>
        <a
            href={WA_MAIN}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-btn"
            aria-label="Chamar no WhatsApp"
            title="Chamar no WhatsApp"
            className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#ff6200] hover:bg-[#e05600] text-white flex items-center justify-center shadow-2xl transition-colors"
        >
            <span className="absolute inset-0 rounded-full bg-[#ff6200] animate-ping opacity-25 pointer-events-none" />
            <MessageCircle className="w-7 h-7 sm:w-8 sm:h-8" />
        </a>
    </div>
);
